module.exports = __webpack_public_path__ + "img/08.18fdbbd3.png";